import { useState, useEffect } from 'react';

const LOADING_TIMEOUT = 5000; // 5 seconds

export const useLoadingTimeout = (initialLoading = false) => {
    const [loading, setLoading] = useState(initialLoading);
    const [timeoutReached, setTimeoutReached] = useState(false);

    useEffect(() => {
        let timeoutId;

        if (loading) {
            timeoutId = setTimeout(() => {
                setTimeoutReached(true);
                setLoading(false);
            }, LOADING_TIMEOUT);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [loading]);

    const startLoading = () => {
        setTimeoutReached(false);
        setLoading(true);
    };

    const stopLoading = () => {
        setLoading(false);
        setTimeoutReached(false);
    };

    return {
        loading,
        timeoutReached,
        startLoading,
        stopLoading
    };
}; 